import { useCountrySettings } from '../components/ChannelContext/useCountrySettings';
import freeShippingQuery from './FreeShippingQuery.gql';
export default function useFreeShippingCheck({ cartTotal } = { cartTotal: null }) {
    var _a;
    const { selectedCountrySettings, loading } = useCountrySettings({
        countrySettingsQuery: freeShippingQuery
    });
    const limit = (_a = selectedCountrySettings === null || selectedCountrySettings === void 0 ? void 0 : selectedCountrySettings.shipping) === null || _a === void 0 ? void 0 : _a.freeShippingLimit;
    const shippingIsInQuery = typeof limit !== 'undefined';
    const noFreeShippingConfigured = !limit && shippingIsInQuery;
    if (noFreeShippingConfigured || !shippingIsInQuery) {
        return {
            loading,
            freeShippingLimit: limit,
            freeShippingConfigured: false,
            hasMetLimit: false,
            untilLimit: null
        };
    }
    return {
        loading,
        freeShippingLimit: limit,
        freeShippingConfigured: true,
        hasMetLimit: limit.incVat <= cartTotal.incVat,
        untilLimit: {
            incVat: limit.incVat - cartTotal.incVat,
            exVat: limit.exVat - cartTotal.exVat
        }
    };
}
//# sourceMappingURL=useFreeShippingCheck.js.map